import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../service/customer.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfirmationService } from 'primeng/api';
import { PreformanceStatusService } from '../service/preformance-status.service';

@Component({
  selector: 'app-customer-list-loss-work-capacity',
  templateUrl: './customer-list-loss-work-capacity.component.html',
  styleUrls: ['./customer-list-loss-work-capacity.component.css']
})
export class CustomerListLossWorkCapacityComponent implements OnInit {

  arrMonth: any[] = [];
  selectedMonth: any = null;
  accountManagers: any[];
  accountManagerSelected: any = null;
  customers: any[];
  customersSelected: any[];
  
  resultTable: any[] = null;
  cols: any[];
  colsDetails: any[];
  msgs: any[] = [];
  showButtonsColumn: any = true;
  selectedRowData: any = null;
  isShowDetails: boolean = false;

  constructor(private dataService: CustomerService, private performanceService: PreformanceStatusService, private router: Router) { }

  ngOnInit() {
    this.performanceService.GetMonths().subscribe((result: any) => {
      this.arrMonth = result;
      this.selectedMonth = this.arrMonth[this.arrMonth.length - 1];
    });

    this.performanceService.getAccountManagersDDL().subscribe((result: any) => {
      this.accountManagers = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת רשימת מנהלי תיקים ');
      });

    // this.fillData();
  }

  accountManagersChanged() {
    this.performanceService.getCustomers(this.accountManagerSelected).subscribe((result: any) => {
      this.customers = result;
      this.customersSelected = [];
    
    },
    (err: HttpErrorResponse) => {
      this.showMessage('error', '', 'תקלה בקבלת רשימת מעסיקים ');
    });
  }

  getData() {
    this.cols = [
      { field: 'IdentityNumber', header: 'זיהוי מעסיק' },
      { field: 'CustomerName', header: 'שם מעסיק' },
      { field: 'ContactEmail', header: 'מייל איש קשר' },
      { field: 'ContactPhone', header: 'טלפון איש קשר' },
      { field: 'InsuranceAgentEmail', header: 'מייל סוכן' },
      { field: 'AccountantEmail', header: 'מייל איש כספים' },
      { field: 'AccountManagerName', header: 'מנהל תיק' },
      

    ];

    this.colsDetails = [
      { field: 'MisparMezaheOved', header: 'ת.ז. עובד' },
      { field: 'FirsName', header: 'שם פרטי' },
      { field: 'LastName', header: 'שם משפחה' },
      { field: 'SugHafrasha', header: 'סוג הפרשה' },
      { field: 'SchumHafrasha', header: 'סכום הפרשה' },
      { field: 'ShiurHafrasha', header: 'שיעור הפרשה' },
      { field: 'ShemKupa', header: 'שם קופה' },
      { field: 'BirthDay', header: 'תאריך לידה' },
      { field: 'FirstReminderSentDate', header: 'תאריך הודעה מקדימה' },
      { field: 'SecondReminderSentDate', header: 'תאריך הודעת מעקב' },
      

    ];

    this.dataService.getCustomerLossWorkCapacityList(this.accountManagerSelected, this.customersSelected, this.selectedMonth).subscribe((result: any) => {
      this.resultTable = result;
    },
      (err: HttpErrorResponse) => {
        this.showMessage('error', '', 'תקלה בקבלת נתוני אכע למעסיקים ');
      });

  }


  showDetails(rowData) {
    this.selectedRowData = rowData;
    this.isShowDetails = true;
  }

  closeDetails() {
    this.selectedRowData = null;
    this.isShowDetails = false;
  }



  showMessage(type, summaryMessage, message): void {
    this.msgs = [];
    this.msgs.push({ severity: type, summary: summaryMessage, detail: message });
  }

}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customer-list-loss-work-capacity/customer-list-loss-work-capacity.component.ts